/**
 * wangjunfa
 * 规范
 * name 大驼峰
 */
const jobsRouter = [
  {
    path: '/jobs/search',
    name: 'JobsSearch',
    component: () => import(/* webpackChunkName: "jobs" */ '@/views/jobs/search')
  },
  {
    path: '/jobs/recommend',
    name: 'JobsList',
    component: () => import(/* webpackChunkName: "jobs" */ '@/views/jobs/list')
  },
  {
    path: '/campus_recruiting/user_show',
    name: 'JobsList1',
    component: () => import(/* webpackChunkName: "jobs" */ '@/views/jobs/list')
  },
  ///comp_recruit_infos/2647
  {
    path: '/comp_recruit_infos/:token',
    name: 'JobDetail',
    component: () => import(/* webpackChunkName: "jobs" */ '@/views/jobs/jobDetail')
  },
  {
    path: '/jobs/mailing',
    name: 'JobsMailing',
    component: () => import(/* webpackChunkName: "jobs" */ '@/views/jobs/mailing')
  },
  {
    path: '/jobs/campus/remind',
    name: 'JobsRemind',
    component: () => import(/* webpackChunkName: "jobs" */ '@/views/jobs/campusRemind')
  },
  {
    path: '/activity/:url',
    name: 'springMoves',
    component: () => import(/* webpackChunkName: "jobs" */ '@/views/jobs/springMoves')
  },
  {
    path: '/jobs/company_job/:token',
    name: 'companyJob',
    component: () => import(/* webpackChunkName: "jobs" */ '@/views/jobs/companyJobSearch')
  }
];
export default jobsRouter;
